/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { AlertController, IonPopover, LoadingController, ModalController } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { NotificationService } from '../../../commons/services/ui/notification.service'
import { ApiService } from '../../../commons/services/api/api.service'
import { PlatformService } from '../../../commons/services/business/platform.service'
import { EmailDomainRestrictionValidator } from '../../../commons/validators/email-domain-restriction.validator'
import { InviteUserModel } from './models/invite-user'
import { EmailUniquenessValidator } from '../../../../src/commons/validators/email-uniqueness.validator'
import { CloneUserModel } from './models/clone-user'
import { GoogleAnalyticsService } from 'ngx-google-analytics'
import { TitleService } from '../../../../src/commons/services/ui/title.service'
import { CacheService } from '../../../../src/commons/services/business/cache.service'
import { ISetUserHierarchy } from '../../../../src/security/models/user-invitation.model'
import { UserApiService } from '../../../../src/security/models/services/users/userApi.service'

@Component({
  selector: 'app-invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss'],
})
export class InviteUserComponent implements OnInit {
  @ViewChild('popoverDom') popoverDom: IonPopover
  public showSuccessMessage = false

  private initializedUser: InviteUserModel = {
    orgId: 0,
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
  }

  @Input() orgId: number
  @Input() user: InviteUserModel = this.initializedUser

  public cloneUser: CloneUserModel
  public callerTitle: string

  public wizardIndex = 1
  public error = null
  public loading
  private googleAnalyticsCategory = 'invite_user'
  public isInternalOrg = false

  public domains: string[] = []
  public inviteUserForm = new FormGroup({
    username: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    firstName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    lastName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    phoneNumber: new FormControl(''),
    accountState: new FormControl(0),
    accountStateDescription: new FormControl(0),
    accountStateColor: new FormControl(''),
    registrationDate: new FormControl(''),
    invitationDate: new FormControl(0),
    lastLogin: new FormControl(0),
    isIpExempt: new FormControl(false),
  })
  claims: number[] = []
  roles: number[] = []
  userHierarchy: ISetUserHierarchy = {
    isAssignedFullHierarchy: false,
    sponsorBankRIds: [],
    enterpriseRIds: [],
    merchantRIds: [],
    programGroupRIds: [],
  }

  constructor(
    public platform: PlatformService,
    public modalController: ModalController,
    public apiService: ApiService,
    public userApiService: UserApiService,
    public loadingController: LoadingController,
    private readonly translate: TranslateService,
    private notificationService: NotificationService,
    private alertController: AlertController,
    protected $gaService: GoogleAnalyticsService,
    private readonly titleAppService: TitleService,
    private cacheService: CacheService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.titleAppService.setTitle(this.translate.instant('administration.inviteUser.pageTitle'))
    await this.load()
  }

  public async load(): Promise<void> {
    try {
      if (this.user == null) {
        this.user = this.initializedUser
      }

      this.isInternalOrg = await this.cacheService.isInternalOrg()

      if (this.cloneUser != null) {
        //get roles and claims from the clone user 
        const userPermissions = await this.userApiService.getUserPermissions(
          this.cloneUser.userId
        )

        this.roles = userPermissions.roles.filter(r => !r.claims.some((w) => w.disableGrantOption)).map((r) => r.rId)
        this.claims = userPermissions.claims.filter(c => !c.disableGrantOption).map((c) => c.rId)
      }

      await this.presentLoading()
      //email domain restriction validation
      this.domains = (await this.userApiService.getEmailDomainRestrictions()) || []
      if (this.domains.length > 0)
        this.inviteUserForm.controls['email'].setValidators(
          Validators.compose([Validators.required, Validators.email, EmailDomainRestrictionValidator(this.domains)])
        )
      this.inviteUserForm.controls['email'].setAsyncValidators([
        EmailUniquenessValidator(this.apiService, this.user.id),
      ])

      this.inviteUserForm.patchValue(this.user)
      this.inviteUserForm.markAsPristine()
    } catch (err) {
      this.error = err
    } finally {
      await this.dismissLoading()
    }
  }

  get canContinue(): boolean {
    switch (this.wizardIndex) {
      case 1:
        return this.inviteUserForm.valid
      case 2:
        return this.claims.length >= 1
      case 3:
        return (
          this.userHierarchy.isAssignedFullHierarchy ||
          this.userHierarchy.merchantRIds.length > 0 ||
          this.userHierarchy.programGroupRIds.length > 0 ||
          this.userHierarchy.sponsorBankRIds.length > 0
        )
    }

    return false
  }

  get hasPendingChanges(): boolean {
    return (this.inviteUserForm.dirty
      || this.claims.length >= 1
      || (
        this.userHierarchy.isAssignedFullHierarchy ||
        this.userHierarchy.merchantRIds.length > 0 ||
        this.userHierarchy.programGroupRIds.length > 0 ||
        this.userHierarchy.sponsorBankRIds.length > 0
      ))
      && this.wizardIndex < 4
  }

  public async dismiss(): Promise<void> {
    if (this.hasPendingChanges) {
      const alert = await this.alertController.create({
        backdropDismiss: false,
        mode: this.platform.isDesktop() ? 'md' : 'ios',
        header: this.translate.instant('administration.inviteUser.pendingChangesHeader'),
        message: this.translate.instant('administration.inviteUser.pendingChangesMessage'),
        buttons: [
          {
            text: this.translate.instant('administration.inviteUser.cancel'),
            role: 'Cancel',
            cssClass: 'ion-margin',
          },
          {
            text: this.translate.instant('administration.inviteUser.close'),
            role: 'Close',
            cssClass: 'ion-margin',
          },
        ],
      })

      await alert.present()

      const { role } = await alert.onDidDismiss()

      if (role === 'Cancel') {
        return
      }
    }

    const modal = await this.modalController.getTop()
    if (modal) {
      this.titleAppService.setTitle(this.callerTitle, false)
      await modal.dismiss()
    }
  }

  public async nextStep(): Promise<void> {

    if (this.isInternalOrg && this.wizardIndex == 2) {
      this.wizardIndex += 2
      this.userHierarchy = { isAssignedFullHierarchy: true } as ISetUserHierarchy
    }
    else if (this.wizardIndex < 4) {
      this.wizardIndex++
    }

    if (this.wizardIndex == 4) {
      await this.inviteUser()
    }
  }

  public previousStep(): void {
    if (this.wizardIndex > 1) {
      this.wizardIndex--
    }
  }

  goToStep(index: number): void {
    this.wizardIndex = index
  }

  public async inviteUser(): Promise<void> {
    const userPayload = {
      orgId: this.orgId,
      firstName: this.inviteUserForm.value?.firstName,
      lastName: this.inviteUserForm.value?.lastName,
      email: this.inviteUserForm.value?.email,
      phoneNumber: '',
      userConfig: {
        permissions: {
          claims: this.claims,
          roles: this.roles,
        },
        hierarchy: this.userHierarchy,
        isIpExempt: false,
      },
    }

    try {
      await this.presentLoading()

      if (this.user.id) {
        await this.userApiService.resendInvitation(this.user.id, userPayload)
        //register GA event
        this.$gaService.event('resend_invitation', this.googleAnalyticsCategory)
      } else {
        await this.userApiService.inviteUser(userPayload)
        //register GA event
        this.$gaService.event('inviting_user', this.googleAnalyticsCategory)
      }

      this.showSuccessMessage = true
    } catch (error) {
      void this.notificationService.showToasterErrorMessage(
        this.translate.instant('administration.userActionsConfirmation.saveError')
      )
      void this.modalController.dismiss()
    } finally {
      await this.dismissLoading()
    }
  }

  private async presentLoading() {
    this.loading = await this.loadingController.create({
      message: this.translate.instant('administration.loading'),
    })
    await this.loading.present()
  }

  private async dismissLoading() {
    await this.loading.dismiss()
  }

  public openDomains(event: MouseEvent): void {
    const rect: DOMRect = (event.target as HTMLElement).getBoundingClientRect()
    const newEvent = new MouseEvent('newMouseEvent', {
      ...event,
      clientX: rect.left,
      clientY: rect.top + rect.height,
    })
    void this.popoverDom.present(newEvent)
  }
}
